<template>
  <div>
    <div class="cartHeader">
      <div class="cartHeaderWrap">
        <h1 class="cartTitle">{{$t('cart')}}</h1>
        <div class="cartCloseBtn" @click="backBtn">{{$t('close')}}</div>
      </div>
    </div>
    <div class="cartContainer">
      <div class="appCartTop" v-if="cartInfo.length > 0">
        <div>
          <div class="orderTag" v-if="qrType == 0">{{$t('orderInStore')}}</div>
          <div class="orderTag" v-else-if="qrType == 1">{{$t('orderForDelivery')}}</div>
          <!-- <div class="cartTableNum" v-if="">테이블 {{tableNo}}</div> -->
        </div>
        <div style="display: flex; align-items: center; padding-top:12px; width: 100%">
          <div class="cartStoreImg" v-if="storeImage"><img :src="storeImage"></div>
          <div class="cartStoreImg" v-else><img src="../assets/img/list_img_empty.png"></div>
          <div class="d-flex flex-space-between w100p flex-x-center" @click="storeIntroUrl">
            <div>
              <div class="cartStoreName">
                <p>{{storeName}}</p>
                <div class="arrow"></div>
              </div>
              <div class="marketName" v-if="marketName">{{marketName}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="cartList" v-for="(cartList,index) in cartInfo" :key="index">
        <div class="cartContentTop">
          <div class="cartMenuName">
            <MenuName :menu='cartList.menu' :mainFlag='1'>
              <strong>{{cartList.menu.name}}</strong>
            </MenuName>
          </div>
          <div class="cartDelBtnLine"></div>
          <div class="cartDelBtn" @click="cartDelete(index)"></div>
        </div>
        <div class="cartContentMid">
          <div class="cartOption">기본</div>
          <div class="cartOptionPrice">{{formatComma(cartList.menu.price)}}원</div>
        </div>
        <div class="cartDetailOption">
          <li v-for='option in cartList.menu.option' :key='option.menuOptionCode'>
            <strong>{{option.detailOption.menuDetailOptionName}}</strong>
            <span>{{formatComma(option.detailOption.price)}}{{$t('MoneyUnit')}}</span>
          </li>
          <!-- 추가 옵션 -->
          <li v-for='option in cartList.menu.additionalOption' :key='option.menuOptionCode'>
            <strong>{{option.menuOptionName}}</strong>
            <span>{{formatComma(option.price)}}{{$t('MoneyUnit')}}</span>
          </li>
          <!-- 선택 옵션 -->
          <li v-for='(option, idx) in cartList.menu.optionalOption' :key='idx'>
            <strong>{{option.detailOption.menuDetailOptionName}}</strong>
            <span>{{formatComma(option.detailOption.price)}}{{$t('MoneyUnit')}}</span>
          </li>
        </div>
        <div class="cartContentBot">
          <div class="cartMenuCountBtn">
            <div :class="cartList.count == 1 ? 'disabledMenuCountMinusBtn' : 'menuCountMinusBtn'" @click="cartUpdate(index,1)"></div>
            <div class="menuCountBtnNum">{{cartList.count}}</div>
            <div class="menuCountPlusBtn" @click="cartUpdate(index,2)"></div>
          </div>
          <div class="cartMenuPrice">{{formatComma(cartList.price * cartList.count)}}<span>원</span></div>
        </div>
      </div>
    </div>
    <div class="paymentBtnWrap" v-if="totalPrice" @click="order">
      <!-- TODO : 2025-12-10 명동 포장 관련 임시 , v-if !isTakeOutStoreIncluded(this.$store.getters.currentStoreCode) 조건 삭제 -->
      <div class="cartMinOrderFee" v-if="!isTakeOutStoreIncluded(this.$store.getters.currentStoreCode)">
        <p>배달최소주문금액 <span>{{formatComma(this.minOrderFee)}}원</span></p>
      </div>
      <div class="paymentBtn" v-if="this.$i18n.locale==='ko'">
        총<span>{{formatComma(totalPrice)}}</span>원 결제하기
      </div>
      <div class="paymentBtn" v-else>
        {{$t('totalPay')}}<span>{{formatComma(totalPrice)}}</span>{{$t('MoneyUnit')}}
      </div>
    </div>
    <div class="cartNoMenu" v-if="!loading && cartInfo.length === 0">
      <img src="@/assets/img/ic_error_36.png">
      <p>{{$t('emptyCart')}}</p>
    </div>
  </div>
</template>
<script>
import service from '@/backend/modnpay_app_api'
import MenuName from '@/components/Common/MenuName.vue'
export default {
  components: { MenuName },
  data () {
    return {
      cartInfo: [],
      totalPrice: '',
      storeCode: '',
      storeName: '',
      storeImage: '',
      minOrderFee: '',
      qrType: '',
      marketName: '',
      loading: true
    }
  },
  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
    this.cartList()
  },
  methods: {
    backBtn () {
      history.back()
    },
    async storeIntroUrl () {
      const req = {
        urlCode: this.storeCode,
        introUrlType: this.qrType
      }
      const { data } = await service.storeIntroUrl(req)
      sessionStorage.removeItem('tradition')
      sessionStorage.removeItem('categoryCode')
      sessionStorage.removeItem('addressByLotNum')
      sessionStorage.removeItem('time')
      window.location.href = data.introUrl
    },
    async cartList () {
      this.loading = true

      const req = {}
      const { data } = await service.appCartList(req)

      if (data.resultCode == 0) {
        this.qrType = data.qrType
        this.totalPrice = data.totalPrice
        this.storeCode = data.storeGroupCode
        this.minOrderFee = data.minOrderFee
        this.storeImage = data.storeImage
        this.storeName = data.storeName
        this.marketName = data.marketName

        this.cartInfo = data.cartList.map(item => {
          const parsedCartInfo = JSON.parse(item.cartInfo)
          const appCartId = item.appCartId
          const price = item.price
          const count = item.count
          return {
            ...parsedCartInfo,
            appCartId,
            price,
            count
          }
        })
      }

      this.loading = false
    },
    async cartDelete (index) {
      const req = {
        appCartId: this.cartInfo[index].appCartId
      }
      const { data } = await service.appCartDelete(req)
      if (data.resultCode == 0) {
        this.cartList()
      }
    },
    async cartUpdate (index, countType) {
      if (countType === 1 && this.cartInfo[index].count > 1) {
        this.cartInfo[index].count--
      } else if (countType === 2) {
        this.cartInfo[index].count++
      }
      const req = {
        appCartId: this.cartInfo[index].appCartId,
        cartInfo: JSON.stringify(this.cartInfo[index]),
        count: this.cartInfo[index].count
      }
      const { data } = await service.appCartUpdate(req)
      if (data.resultCode == 0) {
        this.cartList()
      }
    },
    order () { // 바로결제
      localStorage.setItem('pageType', 1)
      sessionStorage.setItem('cartInfo', JSON.stringify(this.cartInfo))
      sessionStorage.setItem('totalPrice', this.totalPrice)
      this.storeIntroUrl()
    }
  }
}
</script>

<style scoped>

</style>
